import React from "react";
import Preloader from "../helper/Preloader";
import Banner from "../components/Banner";

import NewArrival from "../components/NewArrival";
import CategoriesHomeSection from "../components/CategoriesHomeSection";
import Shipping from "../components/Shipping";

import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
const HomePage = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
     <ScrollToTop smooth color="#FA6400"/>

      {/* ColorInit */}
      <ColorInit color={true} />

  

     
      <Banner />

      {/* FeatureOne */}
      {/* <FeatureOne /> */}

      {/* Promotional */}
      {/* <Promotional /> */}

      {/* FlashSales */}
      {/* <FlashSales /> */}

      {/* ProductList */}
      {/* <ProductList /> */}

      {/* Offer */}
      {/* <Offer /> */}

      {/* Recommended */}
      {/* <Recommended /> */}

      {/* HotDeals */}
      {/* <HotDeals /> */}

      {/* TopVendors */}
      {/* <TopVendors /> */}

      {/* BestSells */}
      {/* <BestSells /> */}

      {/* Delivery */}
      {/* <Delivery /> */}

      {/* Organic */}
      {/* <Organic/> */}

      {/* ShortProduct */}
      {/* <ShortProduct /> */}

      {/* Brand */}
      {/* <Brand/> */}

      {/* Categories Section */}
      <CategoriesHomeSection />

      {/* NewArrivalOne */}
      <NewArrival />

      {/* Shipping */}
      <Shipping />

      {/* Newsletter */}
      {/* <Newsletter /> */}

     


    </>
  );
};

export default HomePage;
